import React from 'react';

const CERTS = [
    { tone: 'bronze', name: 'Bronze', body: 'Basic governance and corporate records complete. Suited to very early-stage or pre-revenue companies.' },
    { tone: 'silver', name: 'Silver', body: 'Full Diligence Pack substantially complete, including financials and commercial evidence. Right for most seed rounds.' },
    { tone: 'gold', name: 'Gold', body: "Directors' questionnaires, warranty drafts, and full IP and contract analysis. For larger rounds or Series A and above." },
];

const STEPS = [
    { n: '1', title: 'Upload once', body: 'Contracts, financials, pitch materials, and board papers into your Data Repository.' },
    { n: '2', title: 'Clarence auto-fills', body: '~60% of your diligence modules populated straight from your own knowledge base.' },
    { n: '3', title: 'You review', body: 'Every answer signed off by a director. Nothing is final until you approve it.' },
    { n: '4', title: 'Pack generated', body: 'Shareable with your programme, investors, and advisors via one controlled link.' },
    { n: '5', title: 'Keep it current', body: 'Every future round, every M&A process — your record is already there.' },
];

const STATS = [
    { tone: 'green', value: '60%', label: 'of modules auto-filled by AI' },
    { tone: 'indigo', value: '40+', label: 'VCs on InvestorMatch' },
    { tone: 'yellow', value: '1x', label: 'upload, used every round' },
];

const AccCohortHeroSection = () => (
    <section className="lp-acc-sec">
        <div className="lp-acc-wrap">
            <span className="lp-acc-kicker" data-lp-reveal>For your cohort companies</span>

            <div className="lp-acc-cohort-hero">
                <div>
                    <h2 className="lp-acc-h2" data-lp-reveal data-lp-delay="60">The pitch gets you the meeting. The Diligence Pack gets you the money.</h2>
                    <p className="lp-acc-sub" data-lp-reveal data-lp-delay="120">You've already beaten the odds — fewer than 1 in 100 companies that approach investors get funded, and your accelerator changed those odds by getting you in the room. What happens next depends on how fast you can answer the questions that come after the pitch. Diligentsia turns investment readiness from a 3-week scramble into an exercise in value creation that can take as little as three days.</p>
                </div>
                <div className="lp-acc-pullquote" data-lp-reveal data-lp-delay="160">"The fastest-closing companies are typically the best-prepared ones."</div>
            </div>

            <div className="lp-acc-cert-row">
                {CERTS.map((c, i) => (
                    <div className={`lp-acc-cert is-${c.tone}`} key={c.name} data-lp-reveal data-lp-delay={i * 80}>
                        <div className="cert-name"><span className="cert-dot" />{c.name}</div>
                        <p>{c.body}</p>
                    </div>
                ))}
            </div>

            <div className="lp-acc-steps5">
                {STEPS.map((s, i) => (
                    <div className="lp-acc-step5" key={s.n} data-lp-reveal data-lp-delay={i * 70}>
                        <div className="s5num">{s.n}</div>
                        <h5>{s.title}</h5>
                        <p>{s.body}</p>
                    </div>
                ))}
            </div>

            <div className="lp-acc-stat-row is-three">
                {STATS.map((s, i) => (
                    <div className={`lp-acc-fstat is-${s.tone}`} key={s.label} data-lp-reveal data-lp-delay={i * 80}>
                        <div className="lp-acc-circle">{s.value}</div>
                        <div className="flabel">{s.label}</div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

export default AccCohortHeroSection;
